import { onMounted, onBeforeUnmount, nextTick } from 'vue'

let observer = null

function wrapTables(root = document) {
    root.querySelectorAll('.wysiwyg-content table').forEach((table) => {
        // Don't wrap an already wrapped table
        if (table.parentElement?.classList.contains('table-wrapper')) {
            return
        }

        const wrapper = document.createElement('div')
        wrapper.className = 'table-wrapper'

        table.parentNode.insertBefore(wrapper, table)
        wrapper.appendChild(table)
    })
}

export function useResponsiveTables() {
    onMounted(async () => {
        await nextTick()

        // Process anything already rendered
        wrapTables()

        // Watch for future v-html updates / dynamically rendered content
        observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType !== Node.ELEMENT_NODE) {
                        continue
                    }

                    // The added node itself might be a table
                    if (node.matches?.('table')) {
                        wrapTables(node.parentElement)
                    }

                    // Or it might contain tables
                    if (node.querySelector?.('table')) {
                        wrapTables(node)
                    }
                }
            }
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    })

    onBeforeUnmount(() => {
        observer?.disconnect()
        observer = null
    })
}
